import React from 'react';
import './clases.css'
import { Fade } from "react-awesome-reveal";


function Clases() {
    return (
    <section className="clasescontainer" id="clasescontainer">
        <div className="clasestexto">
            <Fade bottom delay={100} duration={1000}  fraction={0.2}><h2>CLASES</h2></Fade>
            <Fade bottom delay={100} duration={1000}  fraction={0.3}>
                <p>Amy ejerce la docencia desde hace más de quince años en diversos espacios, incluyendo su trabajo
durante varios años en el Programa Nacional de Orquestas y Coros Infantiles y Juveniles para el
Bicentenario del Ministerio de Educación de la Nación Argentina. En este programa, se desempeñó
como docente de violín y formadora de docentes, con un enfoque especial en el trabajo grupal.</p>
                <p>Su
experiencia docente abarca un público variado, desde infancias hasta adultos. En sus clases, aborda
tanto la técnica específica del instrumento como elementos generales de la música, tales como la
improvisación y la composición.</p>
                        
            </Fade>
        </div>
        <div className="clasesspotify">
            <Fade>
                <iframe className='stliframe' src="https://open.spotify.com/embed/artist/3AGGyNDwL2K76SPArpC4QN?utm_source=generator&theme=0" title="Spotify media player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" loading="lazy"></iframe>
            </Fade>
        </div>
    </section>
)
}

export default Clases